import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import About from './pages/About';
import TitleServices from './pages/services/TitleServices';
import CurativeServices from './pages/services/CurativeServices';
import SettlementServices from './pages/services/SettlementServices';
import TaxServices from './pages/services/TaxServices';
import ScrollToTop from './components/ScrollToTop';
import TitleCommitmentServices from './pages/services/TitleCommitmentServices';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <main className="flex-grow">
          <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/title-services" element={<TitleServices />} />
              <Route path="/title-commitment-services" element={<TitleCommitmentServices />} />
              <Route path="/curative-services" element={<CurativeServices />} />
              <Route path="/settlement-services" element={<SettlementServices />} />
              <Route path="/tax-services" element={<TaxServices />} />
              {/* <Route path="/careers" element={<Careers />} /> */}
              <Route path="/contact" element={<Contact />} />
            </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

